(function(angular){
	'use strict';

	angular
		.module('modalModule')
		.controller('LeavingFundriseModalController', [
			'close',
			'ignoreClose',
			'text',
			LeavingFundriseModalFunction
		]);

	function LeavingFundriseModalFunction(
		close,
		ignoreClose,
		text
	){
		var leavingFundriseModal = this;
		leavingFundriseModal.close = close;
		leavingFundriseModal.ignoreClose = ignoreClose;
		leavingFundriseModal.text = text;

		leavingFundriseModal.continue = function() {
			close({success: true});
		};
	}
})(window.angular);